import React, { useState } from 'react'
import { ArrowRight, Button, CharacterMood, LottieCharacter, Typography } from '@astrid/components'
import WordsPractice from 'components/WordsPractice/WordsPractice'
import { Book, BookMode, BookProgress } from 'store/services/Book'

import styles from './DifficultWordsPractise.module.scss'

interface DifficultWordsPractiseProps {
  book: Book
  bookMode: BookMode
  bookProgress: BookProgress
  onFinish: () => void
}

const DifficultWordsPractise: React.FC<DifficultWordsPractiseProps> = ({ bookProgress, bookMode, book, onFinish }) => {
  const [start, setStart] = useState(false)
  const [characterMood, setCharacterMood] = useState<CharacterMood>('correct')

  if (start) {
    return (
      <WordsPractice
        numberOfWordsToPractice={3}
        words={bookProgress.difficultWords}
        isPracticePage={true}
        onFinishPractice={onFinish}
        bookData={{
          book,
          bookMode: bookMode!,
          bookProgress
        }}
      />
    )
  } else {
    return (
      <div className={styles.container}>
        <Typography variant="exerciseL">Let's try the hardest words again!</Typography>
        <LottieCharacter
          mood={characterMood}
          changeCharacterMood={setCharacterMood}
          characterName="Abbe"
          neverBored
          className={styles.character}
        />
        <Button onClick={() => setStart(true)} className={styles.continue}>
          Continue <ArrowRight />
        </Button>
      </div>
    )
  }
}

export default DifficultWordsPractise
